export const handleBeforeRequest = (event) => {
  if (event.target.hasAttribute("data-spinner")) {
    const spinnerSelector = event.target.getAttribute("data-spinner");
    const spinnerElement = document.querySelector(spinnerSelector);
    if (spinnerElement) {
      spinnerElement.classList.add("spinner");
    }
  }
};

export const handleAfterRequest = (event) => {
  if (event.target.hasAttribute("data-spinner")) {
    const spinnerSelector = event.target.getAttribute("data-spinner");
    const spinnerElement = document.querySelector(spinnerSelector);
    if (spinnerElement) {
      spinnerElement.classList.remove("spinner");
    }
  }
};
